<template>
  <section class="items-center">
    <vs-row class="df-row mb-base" vs-type="flex" vs-justify="space-around">
      <vs-col class="df-col items-left" vs-justify="center" vs-align="center" vs-w="5" vs-sm="12">
        <h3 class="section__h3 mb-base">Enable data-driven, personalized Employee Feedback</h3>
        <p class="section__p mb-base">Give a data-driven career prediction tool to your HR for fresh hiring or even internal counselling and decision making.</p>
        <ul class="section_ul">
          <li class="mb-2"><vs-icon class="mr-3" color="#44CC88" icon="icon-check-circle" icon-pack="feather"/>Employee Personality Self-Assessment</li>
          <li class="mb-2"><vs-icon class="mr-3" color="#44CC88" icon="icon-check-circle" icon-pack="feather"/>Feedback based Hidden Strengths / Blind Spots</li>
          <li class="mb-2"><vs-icon class="mr-3" color="#44CC88" icon="icon-check-circle" icon-pack="feather"/>Talent Analysis and Development Reports</li>
        </ul>
      </vs-col>
      <vs-col class="df-col" vs-type="flex" vs-justify="center" vs-align="center" vs-w="5" vs-sm="12">
        <img class="univ-df-img" src="../../../../src/assets/images/demo/Employee-Feedback.png" align="center"/>
      </vs-col>
    </vs-row>
    <vs-row class="df-row mb-base" vs-type="flex" vs-justify="space-around">
      <vs-col class="df-col" vs-type="flex" vs-justify="center" vs-align="center" vs-w="5" vs-sm="12">
        <img class="univ-df-img" src="../../../../src/assets/images/demo/Self-Improvement.png" align="center"/>
      </vs-col>
      <vs-col class="df-col items-left" vs-justify="center" vs-align="center" vs-w="5" vs-sm="12">
        <h3 class="section__h3 mb-base">Personality Lab for Self-Improvement and direction</h3>
        <p class="section__p mb-base">Personality based tools to map behavioral traits to career profiles. Create self-development plans and identify specific actions that you can take to be more successful.</p>
        <ul class="section_ul">
          <li class="mb-2"><vs-icon class="mr-3" color="#44CC88" icon="icon-check-circle" icon-pack="feather"/>Career inclinations</li>
          <li class="mb-2"><vs-icon class="mr-3" color="#44CC88" icon="icon-check-circle" icon-pack="feather"/>Behavioural responses to career situations</li>
          <li class="mb-2"><vs-icon class="mr-3" color="#44CC88" icon="icon-check-circle" icon-pack="feather"/>Self-Development guides</li>
        </ul>
      </vs-col>
    </vs-row>
    <vs-row class="df-row mb-base" vs-type="flex" vs-justify="space-around">
      <vs-col class="df-col items-left" vs-justify="center" vs-align="center" vs-w="5" vs-sm="12">
        <h3 class="section__h3 mb-base">Automated guidance to build career roadmaps.</h3>
        <p class="section__p mb-base">Situation Comparison' and 'Self-Development' reports to prepare for future challenges or to get better at the career challenges that you currently face.</p>
        <ul class="section_ul">
          <li class="mb-2"><vs-icon class="mr-3" color="#44CC88" icon="icon-check-circle" icon-pack="feather"/>Talent Analysis report</li>
          <li class="mb-2"><vs-icon class="mr-3" color="#44CC88" icon="icon-check-circle" icon-pack="feather"/>Self-Development roadmaps</li>
          <li class="mb-2"><vs-icon class="mr-3" color="#44CC88" icon="icon-check-circle" icon-pack="feather"/>Training need analysis</li>
        </ul>
      </vs-col>
      <vs-col class="df-col" vs-type="flex" vs-justify="center" vs-align="center" vs-w="5" vs-sm="12">
        <img class="univ-df-img" src="../../../../src/assets/images/demo/career roadmaps.png" align="center"/>
      </vs-col>
    </vs-row>
  </section>
</template>

<script>
  export default {
    name: "DetailedFeatures"
  }
</script>

<style scoped>
  .items-center {
    text-align: center;
    text-align: -moz-center;
    text-align: -webkit-center;
  }
  .items-left {
    text-align: left;
    text-align: -moz-left;
    text-align: -webkit-left;
  }
  section {
    position: relative;
    padding: 5rem;
    background: #FFFFFF;
  }
  .df-row {
    margin: 0 0 10rem 0!important;
    width: 75%!important;
  }
  .section__h3 {
    font-style: normal;
    font-weight: 600;
    font-size: 32px;
    line-height: 40px;
    color: #231D4F;
  }
  .section__p {
    font-style: normal;
    font-weight: 400;
    font-size: 12px;
    line-height: 22px;
    color: #848199;
  }
  .section_ul li {
    font-style: normal;
    font-weight: 400;
    font-size: 12px;
    line-height: 20px;

    flex: none;
    order: 1;
    align-self: center;
    flex-grow: 0;
    margin: 15px 0px;
    color: #848199;
  }
  .univ-df-img {
    width: 500px;
  }

  /*===============================================*/
  /* MEDIA QUERIES	 						 */
  /*===============================================*/

  @media (max-width: 1200px) {
    section {
      padding: 5rem 2rem;
      background: #FFFFFF;
    }
    /*.section__p {
      width: -webkit-fill-available;
      width: -moz-available;
    }*/
    .univ-df-img {
      width: -webkit-fill-available;
      width: -moz-available;
    }
    .df-row {
      margin-top: 0;
    }
    .df-col {
      margin-bottom: 5rem;
    }
  }
</style>
